
import { createTag as _createTag } from '@/api/tag/create';

export default {
  props: {
    onSuccess: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      formConfig: {
        size: 'small',
        statusIcon: true
      },

      formItemList: [{
        label: '标签',
        prop: 'name',
        type: 'input',
        width: 300,
        rules: [{
          required: true,
          message: '请填写标签',
          trigger: 'blur'
        }],
        params: {
          maxlength: 30
        }
      }],

      formValue: {
        name: '',
        type_id: 13
      },

      loading: false
    };
  },


  methods: {
    createTag: function createTag() {
      var _this = this;

      this.loading = true;
      _createTag(this.formValue).then(function (res) {
        _this.loading = false;
        _this.$emit('success');
      }).catch(function () {
        _this.loading = false;
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) _this2.createTag();
      });
    },
    cancel: function cancel() {
      this.$refs.form.resetFields();
      this.$emit('cancel');
    },
    resetFields: function resetFields() {
      this.$refs.form.resetFields();
    }
  }
};